import type { FunctionComponent } from 'react';

import type { IAccount, IPaymentMethod } from '@endeavour/payment-integration';

import { createStyleHelper, createClassName } from '../../../shared/utils/class-names';
import { PaymentMethod } from '../payment-method/payment-method';

import styles from './select-method.module.scss';

const style = createStyleHelper(styles, 'select-method');

export interface ISelectMethodProps {
    className?: string;
    paymentMethods: IPaymentMethod[];
    savedMethods?: IAccount[];
}

export const SelectMethod: FunctionComponent<ISelectMethodProps> = ({
    className,
    paymentMethods,
    savedMethods,
}) => {
    return (
        <div className={createClassName([className, style()])}>
            {savedMethods && savedMethods.length > 0
                ? savedMethods.map((account) => {
                      return (
                          <PaymentMethod
                              className={style('method')}
                              key={account.accountId}
                              paymentMethod={account.method}
                              savedMethodName={account.name}
                              accountId={account.accountId}
                          />
                      );
                  })
                : null}

            {savedMethods && savedMethods.length > 0 ? (
                <div className={style('divider')}></div>
            ) : null}

            {paymentMethods.map((item) => {
                return (
                    <PaymentMethod className={style('method')} key={item.id} paymentMethod={item} />
                );
            })}
        </div>
    );
};
